<template>
  <div>
    <div id="top_of_everything"></div>
    <form id="top_of_form" class="form one grg40 needs-validation" @submit="submitForm" method="post">
      <div class="input-group" v-if="typeof validationErrors !== 'undefined'">
        <ul class="invalid-feedback">
          <p><strong>There were some errors in your submission:</strong></p>
          <li v-for="(value,key,index) in validationErrors">
            {{ value[0] }}
          </li>
        </ul>
      </div>
      <input v-model="donation.id" type="hidden" value="donationResponse.id">
      <div v-if="campaign_id === '2'">
        <recipients v-on:updateRecipients="setRecipients"/>
        <input :value="campaign_id" type="hidden">
        <input :value="sub_campaign_id" type="hidden">
      </div>
      <div v-if="debit && recurring" class="input-group one grg20">
        <h4 class="bold pc1">Debit Order Details</h4>
        <div class="input-group one grg10">
          <label>How many times do you want the donation to re-occur?</label>
          <radio-component id="bob" v-model="donation.iterations" :radioOptions="recurringOptions" class-name="recur-iterations" name="iterations"></radio-component>
        </div>
        <div class="input-group one grg10">
          <label>What day would you like the subsequent donations to trigger?</label>
          <radio-component v-model="donation.iteration_date" :radioOptions="recurringDateOptions" class-name="recur-date" name="iteration_date"></radio-component>
        </div>
      </div>
      <div class="seperator"></div>
      <div v-if="!preload" class="input-group one grg20">
        <div class="input-group one grg20">
          <h4 class="bold pc1">Dedicate this Donation</h4>
          <radio-component v-model="donation.dedicate" :radioOptions="radioOptions" name="dedicate"></radio-component>
          <div v-if="donation.dedicate === '1'">
            <div class="input-group one grg10">
              <h4 class="bold pc1">Dedication Type</h4>
              <div class="currency-picker" v-for="option in dedicateTypeOptions" :key="option.key">
                <div class="form-check two gcg10">
                  <input v-model="donation.dedicate_type" class="form-check-input" type="radio" name="dedicate_type" :id="'dedicate_type' + option.key" :value="option.key">
                  <label class="form-check-label" :for="'dedicate_type' + option.key">
                    {{ option.value }}
                  </label>
                </div>
              </div>
            </div>
            <br>
            <div class="input-group one grg10">
              <h4 class="bold pc1">{{ dedicateTypeOptions.find(item => item.key === donation.dedicate_type).transitive }} Details</h4>
              <text-input v-model="donation.dedicate_first_name"
                          :class="`first-name '  ${typeof validationErrors !== 'undefined' && validationErrors.dedicate_first_name ? ' is-invalid' : ''}`"
                          :label="dedicateTypeOptions.find(item => item.key === donation.dedicate_type).transitive + 'First Name'" :required="true" id="dedicate_first_name" :placeholder="dedicateTypeOptions.find(item => item.key === donation.dedicate_type).transitive + ' First Name'"/>
              <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.dedicate_first_name"></lara-error>
              <text-input v-model="donation.dedicate_last_name" className="last-name" label="Honoroee Last Name" :required="false" id="last_name" :placeholder="dedicateTypeOptions.find(item => item.key === donation.dedicate_type).transitive + ' Last Name'"/>
            </div>
          </div>
        </div>
      </div>

      <div class="seperator"></div>

      <div class="input-group two gcrg20">
        <h4 class="col2-span bold pc1">Personal Info</h4>
        <div class="col2-span form-group grg10">
          <sub>* Some fields are required for Section 18A purposes.</sub>
        </div>
        <div class="form-group grg10">
          <input class="form-control" v-model="donation.first_name" id="first_name" placeholder="First Name">
          <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.first_name"></lara-error>
        </div>
        <div class="form-group grg10">
          <input class="form-control" v-model="donation.last_name" id="last_name" placeholder="Last Name">
          <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.last_name"></lara-error>
        </div>
        <div class="col2-span form-group grg10">
          <input class="form-control" v-model="donation.email" type="email" id="email" placeholder="Email">
          <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.email"></lara-error>
        </div>




        <!-- ================================== Hiding for now ================================================= -->
        <!-- <div class="col2-span form-group grg10">
          <textarea rows="5" class="form-control" v-model="donation.physical_address" id="physical_address" placeholder="Physical Address"></textarea>
          <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.physical_address"></lara-error>
        </div>
        <div class="col2-span form-group grg10">
          <input class="form-control" v-model="donation.person_id_number" id="person_id_number" placeholder="ID Number">
          <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.person_id_number"></lara-error>
        </div>
        <div class="col2-span form-group grg10">
          <input class="form-control" v-model="donation.tax_reference_number" id="tax_reference_number" placeholder="TAX Reference Number">
          <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.tax_reference_number"></lara-error>
        </div> -->
        <!-- =================================================================================== -->      
        
        


        <div class="form-check two gcg10 col2-span">
          <input v-model='donation.anonymous' type="checkbox" id="anonymous" value="anonymous" />
          <label class="form-check-label" for="anonymous">Make this an anonymous donation</label>
        </div>
        <div class="form-group col2-span grg10">
          <vue-tel-input v-model="donation.phone_number" v-bind="telInputConfig"></vue-tel-input>
          <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.phone_number"></lara-error>
        </div>
        <div class="form-group col2-span comment">
          <textarea v-model="donation.comment" name="comment" class="form-control" placeholder="Leave a comment (optional)" />
        </div>
      </div>

      <div class="seperator"></div>

      <div v-if="!preload">
        <div class="input-group one grg20">
          <h4 class="bold pc1">Select Payment Currency</h4>
          <currency-picker v-on:input="setChosenCurrency"  v-bind:currencies="currencies" v-bind:chosen-currency="chosenCurrency"/>
        </div>
      </div>

      <div class="seperator"></div>

      <div class="input-group one grg20">
        <h4 class="bold pc1">Choose Donation Amount in {{ chosenCurrency.description }}</h4>
        <amount-component :symbol="chosenCurrency.symbol" :emoji="chosenCurrency.emoji" :makeReadOnly="useCustomAmount" v-model="donation.original_amount" :amount="donation.original_amount" className="donation-amount" placeholder="Enter the amount you wish to donate" label="Donation Amount" id="amount" :currency="chosenCurrency.code"/>
        <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.amount"></lara-error>
        <currency-conversion-hover v-on:finalAmountChanged="setConvertedAmount" :emoji="chosenCurrency.emoji" :chosenCurrency="chosenCurrency" v-if="chosenCurrency.code !== 'ZAR' && donation.original_amount !== undefined && donation.original_amount !== ''" :amount="donation.original_amount" />
      </div>
      <div class="seperator" v-if="hideCampaignSelector === false"></div>
      <div class="input-group grg10" v-if="hideCampaignSelector === false">
        <h4 class="bold pc1">Choose Which Campaign This Donation Is For</h4>
        <select style="appearance: auto; -webkit-appearance: initial " v-model="donation.campaign_id" name="campaign_id" id="campaign_id" class="form-control" @change="checkForFundraisingEvent">
          <option :selected="donation.campaign_id === campaign.id" v-for="campaign of campaigns" :value="campaign.id">{{ campaign.name }}</option>
        </select>
        <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.department"></lara-error>
      </div>
      <!-- <div v-if="campaigns.length > 0 && typeof donation.campaign_id !== 'undefined' && donation.campaign_id !== 2">
        <div> {{ campaigns.find(item => { return item.id === donation.campaign_id}).help_text }}</div>
      </div> -->


      <div class="seperator"></div>
      <div v-if="!hideRecurring && (!debit && recurring)" class="input-group one grg20">
        <h4 class="bold pc1">Make this a recurring donation</h4>
        <radio-component v-model="donation.recurring" :radioOptions="recurringYesNo" class-name="recur" name="recurring" :value="donation.recurring"></radio-component>
        <div class="input-group one grg10" v-if="donation.recurring === '1'">
          <label>How many times do you want the donation to re-occur?</label>
          <radio-component id="bob2" v-model="donation.iterations" :radioOptions="recurringOptions" class-name="recur-iterations" name="iterations"></radio-component>
        </div>
        <div class="input-group one grg10" v-if="donation.recurring === '1'">
          <label>What day would you like the subsequent donations to trigger?</label>
          <radio-component v-model="donation.iteration_date" :radioOptions="recurringDateOptions" class-name="recur-date" name="iteration_date"></radio-component>
        </div>
      </div>

      <div v-if="fundraisersLoaded && !eventDetails.singular_event" class="input-group grg10">
        <h4 class="bold pc1">{{ eventDetails.noun_plural }} Sponsored By This Donation</h4>
        <multiselect v-if="typeof fundraisersByEvent !== 'undefined'" v-model="chosenFundraisers" :options="fundraisersByEvent" :close-on-select="false" :multiple="true" label="full_name" track-by="id" @input="fundraisersAdded" :allow-empty="false"></multiselect>
        <p v-if="typeof fundraisersText !== 'undefined'">{{ fundraisersText }}</p>
      </div>
      <div v-if="fundraisersLoaded && !eventDetails.singular_event" class="seperator"></div>
      <div class="button">
        <button type="submit" class="primary rounded jstart">Donate Now</button>
      </div>
    </form>
  </div>
</template>

<script>
import TextInput from "./TextInput";
import Checkbox from "./Checkbox";
import {VueTelInput} from 'vue-tel-input';
import TextArea from "./TextArea";
import RadioComponent from "./RadioComponent";
import CurrencyPicker from "./CurrencyPicker";
import AmountComponent from "./AmountComponent";
import CurrencyConversionHover from "./CurrencyConversionHover";
import LaraError from "../general/LaraError";
import Recipients from "./Recipients";
import Multiselect from "vue-multiselect";

export default {

  name: "DonationForm",
  props: {
    hideCampaignSelector: {
      type: Boolean,
      default: false
    },
    campaigns: {
      type: Array,
      default() {
        return []
      }
    },
    recurring: {
      type: Boolean,
      default: false
    },
    debit: {
      type: Boolean,
      default: false
    },
    preload: {
      type: Boolean,
      default: false
    },
    preloadedDonation: {
      type: Object,
      default: undefined
    },
    useCustomAmount: {
      type: Boolean,
      default: false
    },
    customAmount: {
      type: Number,
      default: undefined
    },
    campaign_id: {
      type: String,
      default: 1
    },
    sub_campaign_id: {
      type: String,
      default: '1'
    },
    fundraiser_id: {
      default: undefined
    },
    fundraising_event_id: {
      default: undefined
    }
  },
  components: {
    TextInput,
    Checkbox,
    VueTelInput,
    TextArea,
    RadioComponent,
    CurrencyPicker,
    AmountComponent,
    CurrencyConversionHover,
    LaraError,
    Recipients,
    Multiselect
  },
  data: () => ({
    fundraisersLoaded: false,
    hideRecurring: false,
    eventDetails: undefined,
    fundraisersByEvent: undefined,
    chosenFundraisers: undefined,
    fundraisersText: undefined,
    recipients: undefined,
    currencies: '',
    chosenCurrency: {
      "id":26,
      "code":"ZAR",
      "value":1,
      "active":true,
      "description":"South African Rands",
      "emoji":"🇿🇦",
      "deleted_at":null,
      "created_at":"2020-06-09T17:56:49.000000Z",
      "updated_at":"2020-06-09T18:40:58.000000Z"
    },
    donation: {
      id: Number,
      dedicate: '',
      dedicate_first_name: '',
      dedicate_last_name: '',
      first_name: '',
      last_name: '',
      email: '',
      physical_address: '',
      person_id_number: '',
      tax_reference_number: '',
      anonymous: false,
      phone_number: '',
      comment: '',
      amount: '',
      uuid: '',
      recurring: '0',
      iteration_date: '',
      payment_country: 'ZAR',
      original_amount: '',
      dedicate_type: '1',
      recipients: undefined,
      campaign_id: 1,
      fundraising_event_id: undefined,
      chosen_fundraisers: undefined
    },
    validationErrors: undefined,
    donationResponse: {},
    errors: {},
    loading: false,
    telInputConfig: {
      dynamicPlaceholder: true,
      preferredCountries: ["ZA", "US", "IL", "GB"],
      class: 'col-12'
    },
    radioOptions:
        [
          {
            label: 'No, thank you',
            value: '0',
            id: '0',
            checked: true
          },
          {
            label: 'Yes, please',
            value: '1',
            id: '1',
            checked: false
          }
        ],
    recurringYesNo: [
      {
        label: 'No, thank you',
        value: '0',
        id: 'no',
        checked: true
      },
      {
        label: 'Yes, please',
        value: '1',
        id: 'yes',
        checked: false
      }
    ],
    recurringOptions: [
      {
        label: '3 Months',
        value: '3',
        id: '3_months',
        checked: false
      },
      {
        label: '6 Months',
        value: '3',
        id: '6_months',
        checked: false
      },
      {
        label: '12 Months',
        value: '12',
        id: '12_months',
        checked: false
      },
      {
        label: 'Indefinite',
        value: '99',
        id: '99_months',
        checked: true
      }
    ],
    recurringDateOptions: [
      {
        label: 'First of the month',
        value: '1',
        id: '1st',
        checked: true
      },
      {
        label: 'Fifth of the month',
        value: '5',
        id: '5th',
        checked: false
      },
      {
        label: '25th of the month',
        value: '25',
        id: '25th',
        checked: false
      },
      {
        label: 'Last day of the month',
        value: '31',
        id: '31st',
        checked: false
      }
    ],
    dedicateTypeOptions: [
      {
        key: '1',
        value: 'In Honour Of',
        transitive: 'Honoree'
      },
      {
        key: '2',
        value: 'In Memory Of',
        transitive: 'In Memoriam'
      },
      {
        key: '3',
        value: 'Dedicated To',
        transitive: 'Dedicatee'
      }
    ],
  }),

  methods: {
    getFundraisersForEvent(eventId) {
      let url = '/api/fundraisers-by-event/' + eventId;
      if (typeof this.fundraiser_id !== 'undefined') {
        url += '/' + this.fundraiser_id;
      }
      axios.get(url).then(response => {

        this.fundraisersLoaded = true;
        this.fundraisersByEvent = response.data.fundraisers;
        let pre = response.data.fundraisers.find(item => item.selected === true);
        if (typeof pre !== 'undefined') {
          this.chosenFundraisers = {
            full_name: pre.full_name,
            id: pre.id,
            $isDisabled: true
          }
        }
        this.eventDetails = response.data.event;
        this.donation.fundraising_event_id = this.eventDetails.id;
      });
    },
    fundraisersAdded(value, id) {
      if (value.length > 1) {
        this.fundraisersText = 'You have chosen to sponsor more than one person. Your donation will be split equally among each person.';
      } else {
        this.fundraisersText = undefined;
      }
    },

    checkForFundraisingEvent(event) {
      axios.get('/api/find-fundraising-event/' + event.target.value).then(result => {
        if (result.status === 200) {
          this.hideRecurring = true;
          this.getFundraisersForEvent(result.data.id);
          this.donation.fundraising_event_id = this.fundraising_event_id;
        }
      }).catch(error => {
        this.fundraisersLoaded = false;
        this.hideRecurring = false;
        this.eventDetails = undefined;
        this.fundraisersByEvent = undefined;
        this.chosenFundraisers = undefined;
        this.fundraisersText = undefined;
      });
    },
    setRecipients(data) {
      console.log(data);
      this.donation.recipients = data;
    },
    setConvertedAmount(data) {
      this.donation.amount = data;
    },
    setChosenCurrency(data) {
      this.chosenCurrency = data;
    },
    fakeData() {
      this.donation.first_name = 'David';
      this.donation.last_name = 'Blumenau';
      this.donation.email = 'dblumenau@gmail.com';
      this.physical_address = 'Lorem ipsum';
      this.person_id_number = '1234567890';
      this.tax_reference_number = '65432';
      this.donation.amount = 1000;
      this.donation.comment = 'Lorem ipsum';
      this.donation.dedicate = '0 ';
      this.donation.phone_number = '0762628702';
      this.donation.anonymous = false;
      this.donation.recurring = '1';
      this.donation.iteration_date = 1;
      this.donation.iterations = 6;
    },
    submitForm(event) {
      this.donation.payment_method = 'paygate';
      this.donation.final_rate = this.chosenCurrency.value;
      this.donation.payment_country = this.chosenCurrency.code;
      
      if (this.donation.payment_country === 'ZAR') {
        this.donation.amount = this.donation.original_amount;
      }

      event.preventDefault();
      if (process.env.MIX_APP_USE_DUMMY === 'true') {
        this.fakeData();
      }
      this.donation.sub_campaign_id = this.sub_campaign_id;
      this.donation.chosen_fundraisers = this.chosenFundraisers;
      if (typeof this.fundraising_event_id !== 'undefined') {
        this.donation.fundraising_event_id = this.fundraising_event_id;
      }
      this.submitData();
      this.loading = true;
      setTimeout(() => {
        const point = this.$el.querySelector("#top_of_everything");
        point.scrollIntoView();
      }, 2000);
      return false;
    },
    showPaygateModal() {
      this.$swal.fire({
        icon: 'success',
        title: 'Transferring you to our trusted payment partner, DPO Paygate',
        imageUrl: '/img/collage.png',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        // imageWidth: 593,
        // imageHeight: 95,
        backdrop: `rgba(0,0,0,0.7)`,
        imageAlt: 'Custom image',
        onOpen:  () => {
          this.$swal.showLoading();
        }
      });
    },

    showLoadingModal() {

    },
    directToPaygate(data) {
      this.$swal.hideLoading();
      this.$emit('formSubmittedSuccessfully', data);
    },
    checkWithServer() {
      axios.post('/api/submitDonation', this.donation).then(response => {
        switch (this.donation.payment_method) {
          case 'payfast':
            this.payfast = true;
            this.loading = true;
            this.payfastButtonResponse = response.data;
            break;
          case "paypal":
            this.paypal = true;
            break;
          case "paygate":
            this.showPaygateModal();
            setTimeout(() => {
              this.directToPaygate(response.data);
            }, 2000);
            break;
        }
      }).catch(error => {
        this.$swal.close();
        if (error.response.status === 422) {
          this.showInvalidData(error);
        }
        if (error.response.status === 500) {
          this.showPayGateError();
        }
        this.loading = false;
        this.errors = error.response.data;
      });
    },
    submitData() {
      this.$swal.fire({
        icon: 'info',
        title: 'Validating your information...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        backdrop: `rgba(0, 0, 0, 0.7)`,
        imageAlt: 'Custom image',
        onBeforeOpen: () => {
          this.$swal.showLoading();
          this.checkWithServer();
        }

      });

    },
    showPayGateError() {
      this.$swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
        footer: ` Something went wrong when transferring you to our payment partner, PayGate. We have been alerted of the error and will resolve it as soon as we can. You can contact us at events@dllink.co.za`
      });
    },
    showInvalidData(error) {
      this.validationErrors = error.response.data.errors;
      this.validationMessage = error.response.data.message;
      const point = this.$el.querySelector("#top_of_everything");
      point.scrollIntoView();
      this.$swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: `There were some errors in the details you submitted.`,

      }).then(result => {
        const point = this.$el.querySelector("#top_of_everything");
        point.scrollIntoView();
      });
    },
    formIsValid() {
      return true;
    },
    updateField(e) {
      console.log(e);
    }
  },
  mounted: function() {
    this.$nextTick(function () {
      axios.post('/api/initializeDonation').then(response => {
        this.donationResponse = response.data;
        this.donation.id = this.donationResponse.id;
        this.donation.uuid = this.donationResponse.uuid;
      }).catch(error => {
        console.log(error);
      });
      axios.get('/api/currencies').then(response => {
        this.currencies = response.data;
        this.chosenCurrency = this.currencies.find(item => item.code === 'ZAR');
      });
    });
    this.donation.campaign_id = this.campaign_id;
    if (this.preload) {
      this.donation = Object.assign(this.preloadedDonation);
    }
    if (this.debit) {
      this.donation.recurring = 1;
    }
    if (typeof this.fundraising_event_id !== 'undefined') {
      this.getFundraisersForEvent(this.fundraising_event_id);
      this.debit = false;
    }
  },
  watch: {
    customAmount: {
      immediate: true,
      handler(val, oldVal) {
        if (this.useCustomAmount) {
          this.donation.amount = this.customAmount;
          console.log(this.customAmount);
        }
      }
    },
  }
}
</script>

<style scoped>

</style>
